"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAlgoName = void 0;
exports.getExecutionType = getExecutionType;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));
var _OrderAlgorithmStrategy = _interopRequireDefault(require("../enums/OrderAlgorithmStrategy"));
var _OrderFeature = _interopRequireDefault(require("../enums/OrderFeature"));

var ALGO_NAMES = (0, _objectSpread2.default)({}, _OrderAlgorithmStrategy.default, {
  [_OrderAlgorithmStrategy.default.ICE]: 'ICEBERG',
  [_OrderAlgorithmStrategy.default.PTWAP]: 'PASSIVE TWAP',
  [_OrderAlgorithmStrategy.default.PTWAPSE]: 'PASSIVE TWAP SE',
  [_OrderAlgorithmStrategy.default.PVWAP]: 'PASSIVE VWAP',
  [_OrderAlgorithmStrategy.default.SVWAP]: 'VWAP'
});

var getAlgoName = algo => ALGO_NAMES[algo] || '';
exports.getAlgoName = getAlgoName;
function getExecutionType(order) {
  var algoName = getAlgoName(order.algorithmStrategy) || order.algorithmStrategy;
  if (algoName && order.feature !== _OrderFeature.default.OTC) {
    return algoName;
  }
  return order.feature;
}